export const SECTION_OPTIONS = {
    "STARTUP_RECOGNITION_ENTITIES": "Startup Rrecognition | Entities",
    "STARTUP_RECOGNITION_FORMAT": "Startup Rrecognition | Format",
    "STATUS_REPORT": "Status Report",
    "INFORMATION": "Information",
    "FAQS": "FAQs",
    "GUIDELINE_LOGO": "Guildline logo",
    "GUIDELINE_DETAILS": "Guidline details",
}